import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const offerings = [
  { id:'full-home', title:'Full Home Interiors', icon:'🏠', tag:'Most Popular', desc:'Complete end-to-end home interior design and execution. From concept to keys — we handle everything.', features:['Living Room','Bedrooms','Kitchen','Bathrooms','Dining','Balcony'], startPrice:'₹7L', time:'45 Days', warranty:'10 Years', bg:'hsl(20,8%,88%)' },
  { id:'kitchen', title:'Modular Kitchens', icon:'🍳', tag:'', desc:'German hardware, premium finishes, and smart storage solutions for the heart of your home.', features:['L-Shape','U-Shape','Straight','Island','Parallel','Peninsular'], startPrice:'₹1.5L', time:'20 Days', warranty:'10 Years', bg:'hsl(120,6%,88%)' },
  { id:'wardrobe', title:'Custom Wardrobes', icon:'🚪', tag:'', desc:'Floor-to-ceiling storage with sliding doors, mirror shutters, and intelligent internal organisation.', features:['Sliding','Hinged','Walk-In','Loft','TV Unit','Study Desk'], startPrice:'₹50K', time:'15 Days', warranty:'10 Years', bg:'hsl(40,8%,86%)' },
  { id:'bathroom', title:'Bathroom Renovation', icon:'🛁', tag:'', desc:'Transform your bathroom into a spa-like retreat with premium tiles, fixtures, and custom vanities.', features:['Full Renovation','Tiling','Fixtures','Vanity','Shower','Bathtub'], startPrice:'₹1.2L', time:'10 Days', warranty:'5 Years', bg:'hsl(200,6%,86%)' },
  { id:'living-room', title:'Living Room Design', icon:'🛋️', tag:'', desc:'Statement living rooms that balance comfort and style — TV units, sofas, lighting, and decor.', features:['TV Unit','Seating','Lighting','False Ceiling','Flooring','Decor'], startPrice:'₹1.5L', time:'15 Days', warranty:'10 Years', bg:'hsl(60,7%,87%)' },
  { id:'bedroom', title:'Bedroom Interiors', icon:'🛏️', tag:'', desc:'Serene, functional bedrooms with bespoke furniture, ambient lighting, and space-saving storage.', features:['Bed & Headboard','Wardrobes','Dressing Table','Lighting','Flooring','False Ceiling'], startPrice:'₹1L', time:'12 Days', warranty:'10 Years', bg:'hsl(10,6%,88%)' },
];

const designIdeas = [
  { room:'Living Room', style:'Contemporary', img:'hsl(20,8%,88%)' },
  { room:'Bedroom', style:'Scandinavian', img:'hsl(120,6%,87%)' },
  { room:'Kitchen', style:'Minimalist', img:'hsl(40,8%,86%)' },
  { room:'Dining', style:'Industrial', img:'hsl(200,6%,86%)' },
  { room:'Bathroom', style:'Luxury', img:'hsl(60,7%,88%)' },
  { room:'Study', style:'Modern', img:'hsl(180,5%,87%)' },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="accordion-item">
      <div className="accordion-header" onClick={() => setOpen(!open)}>
        <div className="accordion-title">{q}</div>
        <div style={{ fontSize:22, color:'#8A8F9C', transition:'transform 0.3s', transform:open?'rotate(45deg)':'rotate(0)' }}>+</div>
      </div>
      {open && <div className="accordion-body">{a}</div>}
    </div>
  );
}

function OfferingFaqs({ offering }) {
  const faqs = [
    { q:`How long does ${offering.title} take?`, a:`Our ${offering.title.toLowerCase()} typically takes ${offering.time} after design approval. We guarantee this timeline.` },
    { q:'What warranty is included?', a:`We provide a ${offering.warranty} comprehensive warranty covering all structural defects, hardware, and finish quality.` },
    { q:'Can I customize the designs?', a:'Yes! All our designs are fully customizable. Choose from 1500+ options or work with our designer for a bespoke solution.' },
    { q:'Do you provide EMI options?', a:'Yes, we offer 0% EMI up to 48 months with leading banks and NBFCs.' },
  ];
  return (
    <section className="section">
      <div className="container" style={{ maxWidth:720 }}>
        <div className="section-label">FAQ</div>
        <h2 className="section-title" style={{ marginBottom:36 }}>Common Questions</h2>
        {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} />)}
      </div>
    </section>
  );
}

function OfferingDetail({ offering, navigate }) {
  const [activeTab, setActiveTab] = useState('overview');
  return (
    <div style={{ paddingTop:68 }}>
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-label">{offering.icon} Offerings</div>
          <h1 className="page-hero-title">{offering.title}</h1>
          <p className="page-hero-sub">{offering.desc}</p>
          <div style={{ display:'flex', gap:32, marginTop:28 }}>
            {[['Starting From', offering.startPrice, '#fff'],['Delivery', offering.time, '#fff'],['Warranty', offering.warranty, '#c4a882']].map(([l,v,c]) => (
              <div key={l}>
                <div style={{ fontSize:22, fontFamily: "'Montserrat', 'Inter', sans-serif", color:c }}>{v}</div>
                <div style={{ fontSize:11, color:'#7FD0DA', letterSpacing:1, textTransform:'uppercase' }}>{l}</div>
              </div>
            ))}
          </div>
          <div style={{ display:'flex', gap:16, marginTop:32 }}>
            <button className="btn-gold" onClick={() => navigate('/consult')}>Get Free Quote</button>
            <button className="btn-outline" style={{ color:'#fff', borderColor:'rgba(255,255,255,0.3)' }} onClick={() => navigate('/calculator/home')}>Price Calculator</button>
          </div>
        </div>
      </div>

      <div style={{ background:'#fff', borderBottom:'1px solid #E1E3EE', padding:'0', position:'sticky', top:68, zIndex:100 }}>
        <div className="container">
          <div style={{ display:'flex' }}>
            {['overview','gallery','process','faqs'].map(t => (
              <button key={t} className={`tab-btn ${activeTab===t?'active':''}`} onClick={() => setActiveTab(t)} style={{ textTransform:'capitalize' }}>{t}</button>
            ))}
          </div>
        </div>
      </div>

      {activeTab === 'overview' && (
        <section className="section">
          <div className="container">
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:64 }}>
              <div>
                <div className="section-label">What's Included</div>
                <h2 className="section-title" style={{ marginBottom:24 }}>{offering.title}<br/>Package</h2>
                <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:32 }}>
                  {offering.features.map(f => (
                    <span key={f} style={{ padding:'8px 16px', background:'#ECEEF6', fontSize:13, color:'#343F86', fontWeight:500 }}>✓ {f}</span>
                  ))}
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
                  {[
                    { icon:'🎨', title:'3D Design Visualization', desc:'See your space before we build it' },
                    { icon:'🏭', title:'Factory-Made Quality', desc:'Precision manufacturing, not site carpentry' },
                    { icon:'🚚', title:'Free Delivery & Installation', desc:'End-to-end service included' },
                    { icon:'🛡️', title:`${offering.warranty} Warranty`, desc:'Comprehensive coverage on all work' },
                  ].map((item, i) => (
                    <div key={i} style={{ display:'flex', gap:16, alignItems:'flex-start' }}>
                      <span style={{ fontSize:28, flexShrink:0 }}>{item.icon}</span>
                      <div>
                        <div style={{ fontSize:15, fontWeight:600, color:'#343F86', marginBottom:3 }}>{item.title}</div>
                        <div style={{ fontSize:13, color:'#5B6072' }}>{item.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <div style={{ height:400, background:offering.bg, display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <span style={{ fontSize:64 }}>{offering.icon}</span>
                </div>
                <div style={{ background:'#343F86', padding:'24px', color:'#fff', textAlign:'center' }}>
                  <div style={{ fontSize:12, color:'#8A8F9C', marginBottom:4 }}>Starting From</div>
                  <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:40, color:'#fff' }}>{offering.startPrice}</div>
                  <div style={{ fontSize:12, color:'#8A8F9C', marginTop:4 }}>Includes design, materials & installation</div>
                  <button className="btn-gold" style={{ marginTop:16, width:'100%' }} onClick={() => navigate('/consult')}>Book Consultation</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {activeTab === 'gallery' && (
        <section className="section">
          <div className="container">
            <div className="card-grid card-grid-3">
              {[1,2,3,4,5,6].map(i => (
                <div key={i} className="portfolio-card">
                  <div style={{ height:220, background:`hsl(${20+i*20},7%,${87-i}%)`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <span style={{ fontSize:12, color:'#8A8F9C', letterSpacing:1 }}>{offering.title} · Project {i}</span>
                  </div>
                  <div className="portfolio-overlay" />
                  <div className="portfolio-info">
                    <div className="portfolio-title">{offering.title}</div>
                    <div className="portfolio-sub">Project {i}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {activeTab === 'process' && (
        <section className="section">
          <div className="container" style={{ maxWidth:700 }}>
            <div className="section-label">How It Works</div>
            <h2 className="section-title" style={{ marginBottom:40 }}>Your Journey With PR Hospital Designers</h2>
            {['Free Home Visit','3D Design Presentation','Material Selection','Factory Production','Delivery & Installation','Handover & Warranty'].map((s, i) => (
              <div key={i} style={{ display:'flex', gap:24, marginBottom:32, alignItems:'flex-start' }}>
                <div style={{ width:48, height:48, background:'#343F86', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:20, flexShrink:0 }}>
                  {String(i+1).padStart(2,'0')}
                </div>
                <div style={{ paddingTop:10 }}>
                  <div style={{ fontSize:16, fontWeight:600, color:'#343F86', marginBottom:6 }}>{s}</div>
                  <div style={{ fontSize:14, color:'#5B6072', lineHeight:1.65 }}>Our team handles every step professionally, keeping you informed throughout.</div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {activeTab === 'faqs' && <OfferingFaqs offering={offering} />}
    </div>
  );
}

export default function Offerings({ type }) {
  const navigate = useNavigate();

  const offering = type ? offerings.find(o => o.id === type) : null;

  if (offering) {
    return <OfferingDetail offering={offering} navigate={navigate} />;
  }

  // All offerings overview
  return (
    <div style={{ paddingTop:68 }}>
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-label">What We Do</div>
          <h1 className="page-hero-title">Our Interior<br/>Design Offerings</h1>
          <p className="page-hero-sub">From complete home transformations to single-room makeovers — we've got you covered.</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
            {offerings.map(o => (
              <div key={o.id} style={{ display:'grid', gridTemplateColumns:'280px 1fr', border:'1px solid #E1E3EE', background:'#fff', overflow:'hidden', transition:'box-shadow 0.3s', cursor:'pointer' }}
                onClick={() => navigate(`/offerings/${o.id}`)}
                onMouseEnter={e => e.currentTarget.style.boxShadow='0 12px 40px rgba(0,0,0,0.08)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow=''}
              >
                <div style={{ background:o.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:56 }}>{o.icon}</div>
                <div style={{ padding:'32px 36px', display:'flex', justifyContent:'space-between', alignItems:'center', gap:24 }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                      <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:24, color:'#343F86' }}>{o.title}</div>
                      {o.tag && <span style={{ background:'#c4a882', color:'#7FD0DA', fontSize:9, fontWeight:700, letterSpacing:1.5, padding:'3px 8px', textTransform:'uppercase' }}>{o.tag}</span>}
                    </div>
                    <p style={{ fontSize:14, color:'#5B6072', lineHeight:1.7, marginBottom:16, maxWidth:480 }}>{o.desc}</p>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                      {o.features.slice(0,4).map(f => <span key={f} style={{ padding:'4px 10px', background:'#ECEEF6', fontSize:11, color:'#3A4060', fontWeight:600 }}>{f}</span>)}
                      {o.features.length > 4 && <span style={{ padding:'4px 10px', background:'#ECEEF6', fontSize:11, color:'#3A4060', fontWeight:600 }}>+{o.features.length-4} more</span>}
                    </div>
                  </div>
                  <div style={{ textAlign:'right', flexShrink:0 }}>
                    <div style={{ fontSize:11, color:'#7FD0DA', letterSpacing:1, textTransform:'uppercase', marginBottom:4 }}>From</div>
                    <div style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:32, color:'#343F86', marginBottom:12 }}>{o.startPrice}</div>
                    <div style={{ display:'flex', gap:16, justifyContent:'flex-end', marginBottom:16 }}>
                      <div style={{ textAlign:'center' }}>
                        <div style={{ fontSize:14, fontWeight:700, color:'#343F86' }}>{o.time}</div>
                        <div style={{ fontSize:10, color:'#8A8F9C' }}>Delivery</div>
                      </div>
                      <div style={{ textAlign:'center' }}>
                        <div style={{ fontSize:14, fontWeight:700, color:'#c4a882' }}>{o.warranty}</div>
                        <div style={{ fontSize:10, color:'#8A8F9C' }}>Warranty</div>
                      </div>
                    </div>
                    <button className="btn-primary" style={{ padding:'10px 20px', fontSize:12 }} onClick={e => { e.stopPropagation(); navigate(`/offerings/${o.id}`); }}>Explore →</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-alt">
        <div className="container">
          <div className="section-header-row">
            <div>
              <div className="section-label">Design Ideas</div>
              <h2 className="section-title">Get Inspired</h2>
            </div>
            <button className="btn-outline" onClick={() => navigate('/projects')}>All Projects</button>
          </div>
          <div className="card-grid card-grid-3">
            {designIdeas.map((d, i) => (
              <div key={i} className="portfolio-card" onClick={() => navigate('/projects')}>
                <div style={{ height:200, background:d.img, display:'flex', alignItems:'center', justifyContent:'center', transition:'transform 0.5s ease' }}
                  onMouseEnter={e => e.currentTarget.style.transform='scale(1.06)'}
                  onMouseLeave={e => e.currentTarget.style.transform=''}
                >
                  <span style={{ fontSize:12, color:'#8A8F9C', letterSpacing:1 }}>{d.room}</span>
                </div>
                <div className="portfolio-overlay" />
                <div className="portfolio-info">
                  <div className="portfolio-title">{d.room}</div>
                  <div className="portfolio-sub">{d.style} Style</div>
                </div>
                <div style={{ padding:'14px 16px', background:'#fff', borderTop:'1px solid #E1E3EE' }}>
                  <div style={{ fontSize:14, fontWeight:600, color:'#343F86' }}>{d.room}</div>
                  <div style={{ fontSize:12, color:'#8A8F9C', marginTop:2 }}>{d.style} Style</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background:'#343F86', padding:'60px 0', textAlign:'center' }}>
        <div className="container">
          <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:36, color:'#fff', marginBottom:16 }}>Not Sure Where to Start?</h2>
          <p style={{ fontSize:15, color:'#8A8F9C', marginBottom:28 }}>Talk to our expert designers — it's free and takes only 15 minutes.</p>
          <button className="btn-gold" onClick={() => navigate('/consult')}>Book Free Consultation</button>
        </div>
      </section>
    </div>
  );
}
